export enum CtaTexts {
  GET_STARTED = 'Get started',
  GET_STARTED_WITH_DISCOUNT = 'Get started with 50% off',
  OPEN_MENU = 'Open Menu',
  BUILD_BOX = 'Build your box',
}
